/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseLogo
 */
export interface InvitationContextResponseEnterpriseLogo {
    /**
     * the url of the company/organization logo
     * @type {string}
     * @memberof InvitationContextResponseEnterpriseLogo
     */
    baseUrl?: string;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseLogo interface.
 */
export function instanceOfInvitationContextResponseEnterpriseLogo(value: object): value is InvitationContextResponseEnterpriseLogo {
    return true;
}

export function InvitationContextResponseEnterpriseLogoFromJSON(json: any): InvitationContextResponseEnterpriseLogo {
    return InvitationContextResponseEnterpriseLogoFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseLogoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseLogo {
    if (json == null) {
        return json;
    }
    return {
        
        'baseUrl': json['baseUrl'] == null ? undefined : json['baseUrl'],
    };
}

export function InvitationContextResponseEnterpriseLogoToJSON(value?: InvitationContextResponseEnterpriseLogo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'baseUrl': value['baseUrl'],
    };
}

